export let ButtonColor = /*#__PURE__*/function (ButtonColor) {
  ButtonColor["Primary"] = "primary";
  ButtonColor["Secondary"] = "secondary";
  ButtonColor["Light"] = "light";
  ButtonColor["Pill"] = "pill";
  return ButtonColor;
}({});
export default ButtonColor;